/**
 * get key-value from window.location.href
 * @param {*} key the param key
 * @returns window.location.href the value of the key
 * @example
 * const value = getUrlParam(key);
 */
export function getUrlParam(key: string): string {
  const url = decodeURI(window.location.href.replace(/^[^?]*\?/, ""));
  const regexp = new RegExp(`(^|&)${key}=([^&#]*)(&|$|)`, "i");
  const paramMatch = url.match(regexp);

  return paramMatch ? paramMatch[2] : "";
}

/**
 * Get language
 * @returns language
 */
export function getLanguage(): string {
  let language =
    localStorage.getItem("basic-demo-language") ||
    getUrlParam("lang") ||
    navigator.language ||
    "zh-cn";
  language = language.replace(/_/, "-").toLowerCase();
  return language;
}

/**
 * Judge mobile device
 */
export const isMobile: boolean =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

/**
 * 检查当前浏览器是否为微信内置浏览器。
 * 该函数不接受任何参数。
 *
 * @returns {boolean} 如果是微信内置浏览器，则返回true；否则返回false。
 */
export function isWeixin(): boolean {
  let ua = navigator.userAgent.toLowerCase(); // 获取浏览器的用户代理字符串，并转换为小写
  console.log('ua===',ua);
  // 使用正则表达式匹配用户代理字符串中是否包含"MicroMessenger"，即微信内置浏览器的标识
  if (/micromessenger/i.test(ua)) {
    return true; // 如果包含，则返回true
  } else {
    return false; // 如果不包含，则返回false
  }
}
